import SlimSelect from 'slim-select'

export default class Contact {
  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.contact--form')
    if (!this.form) return

    this.mailer = this.form.dataset.mailer
    this.initSlimSelect()
    this.presetSujet()
    this.bindCheckbox()
    this.bindSubmit()
  }

  initSlimSelect() {
    const select = this.form.querySelector('.contact--select')
    if (!select) return
    this.slimSelect = new SlimSelect({
      select,
      settings: {
        showSearch: false,
      }
    })
  }

  presetSujet() {
    const sujet = sessionStorage.getItem('sujet_reservation')
    if (!sujet || !this.slimSelect) return
    sessionStorage.removeItem('sujet_reservation')

    const select = this.form.querySelector('.contact--select')
    const match = [...select.options].find(opt => opt.value.trim().toLowerCase() === sujet.trim().toLowerCase())
    if (match) this.slimSelect.setSelected(match.value)
  }

  bindCheckbox() {
    this.el.querySelectorAll('.contact--checkbox-container').forEach(container => {
      container.addEventListener('click', (e) => {
        const checkbox = container.querySelector('.contact--input-checkbox')
        if (e.target !== checkbox) checkbox.checked = !checkbox.checked
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam?.value) return

      this.setState('loading')

      fetch(this.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form),
      })
        .then(res => { if (!res.ok) throw new Error(res.statusText) })
        .catch(err => console.error(err))
        .finally(() => {
          this.setState('sent')
          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
    })
  }

  setState(state) {
    this.form.querySelectorAll('.contact--btn').forEach(btn => btn.classList.remove('is-active'))
    this.form.querySelector(`.contact--btn--${state}`)?.classList.add('is-active')
  }
}
